import SwiperModule from 'www/modules/SwiperModule'
import PopupContent from 'www/modules/PopupContent'
import { dispatchCustomEventGlobally, initI18n } from 'www/utils'

const BLOCK_NAME = 'b-media-slider'
const WRAPPER_BLOCK_NAME = 'b-media-slider-wrapper'
const CLASS_NAMES = {
  picture: `${BLOCK_NAME}__picture`,
  video: `${BLOCK_NAME}__video`,
}

async function initMediaSlider() {
  await initI18n({ bundle: 'modules/PopupContent' })

  const basePopupContentOptions = {
    createHead: false,
    createHideButton: true,
    navigation: true,
    pagination: 'fraction',
    modalOptions: {
      zIndex: 1001,
      useHash: false,
      animation: 'opacity',
    },
    afterClose: () => {
      dispatchCustomEventGlobally('aside-sizes:update')
    },
    sliderOptions: {
      width: 536,
      autoHeight: false,
    },
    markupDataLookup: true,
  }

  new SwiperModule({
    module: {
      modifier: BLOCK_NAME,
      insertNavigation: {
        where: 'beforeend',
        relative: container => container.closest(`.${WRAPPER_BLOCK_NAME}`),
      },
    },
    swiper: {
      pagination: false,
      slidesPerView: 'auto',
      spaceBetween: 16,
      centeredSlides: false,
      roundLengths: false,
    },
  })

  new PopupContent({
    ...basePopupContentOptions,
    id: 'photo-gallery-modal',
    selector: `.${CLASS_NAMES.picture}`,
    modifier: 'b-photo-gallery',
    contentType: 'photo',
    truncateTitle: true,
  })

  new PopupContent({
    ...basePopupContentOptions,
    id: 'video-gallery-modal',
    selector: `.${CLASS_NAMES.video}`,
    modifier: 'b-video-gallery',
    contentType: 'video',
    createDescription: false,
  })
}

initMediaSlider()
